import React, { useCallback, useEffect, useRef, useState } from 'react'

import { Board } from './Board'
import { useToast } from './components/Toast'
import { CreatedGameApi } from './GameApi/CreatedGameApi'
import { Players } from './Players'

export function CreatedGame({ gameApi }: { gameApi: CreatedGameApi }) {
  const [inviteText, setInviteText] = useState<string>('Invite')
  const { showError } = useToast()

  const shareSupported = navigator.share !== undefined

  // GameInner constructs a fresh CreatedGameApi on every render (no stable key),
  // so `gameApi` identity churns. A ran-once ref keeps joinGame to a single
  // invocation while making the effect deps honest, avoiding repeated
  // saveGameModel writes if the effect re-runs.
  const joined = useRef(false)
  useEffect(() => {
    if (joined.current) return
    joined.current = true
    void gameApi
      .joinGame()
      .catch(() => showError('Could not join the game — try again'))
    setInviteText(shareSupported ? 'Invite' : 'Copy invite link')
  }, [gameApi, shareSupported, showError])

  const invite = useCallback(() => {
    if (shareSupported) {
      navigator
        .share({
          title: 'Roroyal Backgammon',
          text: 'Join my game!',
          url: window.location.href,
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      navigator.clipboard.writeText(window.location.href)
      setInviteText('Copied!')
    }
  }, [shareSupported])

  return (
    <div className="game">
      <Players players={gameApi.getPlayers()} />
      <Board board={gameApi.getBoard()} />
      <div className="waiting">
        <p style={{ padding: 20, textAlign: 'center' }}>
          Waiting for another player to join the game...
        </p>
        <button className="share" onClick={invite}>
          {inviteText}
        </button>
        <button onClick={() => window.location.assign(`/`)}>Back</button>
      </div>
    </div>
  )
}
